import React, { useContext } from 'react';
// styles
import { Wrapper, LogoImg } from './Navbar.styles';
// logo
import Logo from '../../images/flamingo.svg';
// bootstrap-react
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
// user context
import { UserContext } from '../../userContext';
// helpers
import { getUsernameFromEmail } from '../../utils/helpers';

const HeaderNavbar = () => {
  const [user, _setUser] = useContext(UserContext);

  const username = user && getUsernameFromEmail(user.email);

  return (
    <Wrapper>
      <Navbar bg='dark' expand='lg' variant='dark' fixed='top'>
        <Container>
          <Navbar.Brand href='/' className='brand'>
            <LogoImg src={Logo} />
            Flamingo Reading Tracker
          </Navbar.Brand>

          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ms-auto'>
              <Nav.Link href='/login'>Login</Nav.Link>
              <Nav.Link href='/sign-up'>Sign Up</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          {username && (
            <h3 className='username ms-2 mt-2'>
              {getUsernameFromEmail(user.email)}
            </h3>
          )}
        </Container>
      </Navbar>
    </Wrapper>
  );
};

export default HeaderNavbar;
